import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { SectionCard } from "../../../../core/components/SectionCard";
import { StartSection } from "../../../../core/components/StartSection";
import { TextComponent } from "../../../../core/components/TextComponent";
import guiaInvitadosData from "../../../../core/data/db_guia_invitados.json";

export const TypicalPlaces: React.FC = () => {
	const lugaresTipicosSection = guiaInvitadosData.guia_para_invitados.lugares_tipicos;
	const lugaresTipicos = Array.isArray(lugaresTipicosSection.contenido) ? lugaresTipicosSection.contenido : [];

	if (lugaresTipicos.length === 0) {
		return (
			<TextComponent
				variant="h6"
				className="text-center text-gray-500"
			>
				No hay lugares típicos disponibles.
			</TextComponent>
		);
	}

	return (
		<>
			<StartSection
				titulo={lugaresTipicosSection.titulo}
				backgroundImage="lugares_tipicos.jpg"
			/>
			<main className="self-center w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem] mb-4 sm:mb-8">
				<Column
					crossAxisAlignment="center"
					className="bg-white py-5 px-5 gap-4 sm:gap-8 min-h-screen"
				>
					<TextComponent
						variant="h6"
						className="text-center text-gray-700"
					>
						{lugaresTipicosSection.descripcion}
					</TextComponent>

					<Column className="grid grid-cols-1 sm:grid-cols-2 w-full gap-4 sm:gap-8">
						{lugaresTipicos.map((lugar_tipico, index) => (
							<SectionCard
								key={index}
								index={index}
								img={lugar_tipico.img}
								titulo={lugar_tipico.nombre}
								{...(lugar_tipico.tiempo !== "" && { descripcion: `A ${lugar_tipico.tiempo}` })}
								classNameImg="w-2/6 sm:w-2/6 md:w-2/5 aspect-square object-cover rounded-md"
								responsive={false}
							>
								<Column className="flex-grow text-gray-600">
									<TextComponent
										variant="h6"
										className="text-black"
									>
										Referencia:
									</TextComponent>
									<Row
										crossAxisAlignment="center"
										className="gap-4"
									>
										<Row
											crossAxisAlignment="center"
											className="gap-0.5"
										>
											<TextComponent variant="h6">{lugar_tipico.referencia_ubicacion}</TextComponent>
										</Row>
									</Row>
								</Column>
							</SectionCard>
						))}
					</Column>
				</Column>
			</main>
		</>
	);
};
